export default __webpack_public_path__ + "static/favicon-2a18bc81a69da92de7f57b25c3346640.png";